export default __webpack_public_path__ + "static/media/rhino.5bc65586.mp4";